import { render, staticRenderFns } from "./ProductV2.vue?vue&type=template&id=13216204&scoped=true"
import script from "./ProductV2.vue?vue&type=script&lang=js"
export * from "./ProductV2.vue?vue&type=script&lang=js"
import style0 from "./ProductV2.vue?vue&type=style&index=0&id=13216204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13216204",
  null
  
)

export default component.exports